export const faqItems = [
  {
    id: 1,
    questionId: 'faqFormPurposeQuestion',
    answerId: 'faqFormPurposeAnswer',
  },
  {
    id: 2,
    questionId: 'faqWhenToUseQuestion',
    answerId: 'faqWhenToUseAnswer',
  },
  {
    id: 3,
    questionId: 'faqWhatNotToUseForQuestion',
    answerId: 'faqWhatNotToUseForAnswer',
  },
  {
    id: 4,
    questionId: 'faqWhoReceivesSubmissionQuestion',
    answerId: 'faqWhoReceivesSubmissionAnswer',
  },
  {
    id: 5,
    questionId: 'faqWhatInfoToIncludeQuestion',
    answerId: 'faqWhatInfoToIncludeAnswer',
  },
  {
    id: 6,
    questionId: 'faqFeedbackUsedQuestion',
    answerId: 'faqFeedbackUsedAnswer',
  },
];
